require('./lbaCompanyReferenceConfigAuditItem.scss');
const $inject = [];
const lbaCompanyReferenceConfigAuditItem = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '=',
      name: '=',
      cake: '=',
      indexArray: '@'
    },
    bindToController: true,
    controller: 'lbaCompanyReferenceConfigAuditItemCtrl',
    controllerAs: 'vm',
    template: require('./lbaCompanyReferenceConfigAuditItem.html')
  }
};

lbaCompanyReferenceConfigAuditItem.$inject = $inject;

export default lbaCompanyReferenceConfigAuditItem;



// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceConfigAuditItem/lbaCompanyReferenceConfigAuditItemDir.js